module.exports = __webpack_public_path__ + "img/icon_map_0_on_110.04d87029.png";